import { RootState } from '../store';
import { createSelector } from '@reduxjs/toolkit';
import { UserContextInitializationState } from '../../common/slices/userContextSlice';

// Select the auth state from userContext
export const selectAuthState = (state: RootState) => state.userContext;

// These selectors are specific to RTK Query and will be used during auth migration
// Select if login is pending
export const selectIsLoginPending = createSelector(
  selectAuthState,
  authState => authState?.initializationState === UserContextInitializationState.USER_INITIALIZED
);

// Select the auth token
export const selectAuthToken = createSelector(selectAuthState, authState => authState?.idToken);
